import React, {useState, useCallback, useEffect} from 'react'
import PropTypes from 'prop-types'
import {  Grid, Typography, IconButton} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import { sectionHeaderStyles } from '../../../../helpers/styles/sectionHeader.style';
import AddIcon from '@mui/icons-material/Add';
import TuneIcon from '@mui/icons-material/Tune';
const HeadSectionCampaignComponent = ({ title, subTitle, tooltipTitle , onAddButtonClick, onSecondaryAddButtonClick, tooltipTitle2,customStyle = {} }) => {
  let classes = sectionHeaderStyles();
    return (
      <Grid
      container
      direction="row"
      justifyContent="space-between"
      className={`${classes.container} ${customStyle.container ? customStyle.container : ''}`}
    >
      <Grid item>
        <Typography variant="h3" className={ `${classes.sectionTitle} ${customStyle ? customStyle.sectionTitle : ''}`}>
          {title}
        </Typography>
        <p className={ `${classes.sectionSubTitle} ${customStyle ? customStyle.sectionSubTitle : ''}`} dangerouslySetInnerHTML={{__html: subTitle}} >
          
        </p>
      </Grid>
      <Grid item >
       <IconButton
          className={ `${classes.sectionIconButton} ${customStyle ? customStyle.sectionIconButton : ''}`}
          sx={{ 
            backgroundColor: "#1BC3DD",
            borderRadius: "60px",
            marginRight: "20px",
            padding: "4px 10px",
            height: "38px",
            color: "#FFFFFF",
            '&:hover': {
              backgroundColor: "#1BC3DD",
              opacity: 0.8,
            },
          }}
          variant="contained"
          onClick={onAddButtonClick}
        >
        <AddIcon sx={{ color: "#FFFFFFFF", marginRight: "8px", fontSize: "20px" }} />
        <Typography 
          sx={{
            color: "#FFF",
            textAlign: "center",
            fontFamily: "Open Sans",
            fontSize: "18px",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "28px", /* 140% */
            letterSpacing: "0.15px",
          }}>
          Nueva campaña
        </Typography>
        </IconButton>

        <IconButton
            className={ `${classes.sectionIconButton} ${customStyle ? customStyle.sectionIconButton : ''}`}
            sx={{ 
              backgroundColor: "white",
              borderRadius: "60px",
              padding: "4px 10px",
              height: "38px",
              border: "2px solid #1BC3DD",
              color: "#FFFFFF",
              '&:hover': {
                opacity: 0.8,
              },
            }}
            variant="contained"
            onClick={onSecondaryAddButtonClick}
          >
          <TuneIcon sx={{ color: "#1BC3DD", marginRight: "8px", fontSize: "20px" }} />
          <Typography 
            sx={{
              color: "#1BC3DD",
              textAlign: "center",
              fontFamily: "Open Sans",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: "400",
              lineHeight: "28px", /* 140% */
              letterSpacing: "0.15px",
            }}>
            Nueva campaña personalizada
          </Typography>
          </IconButton>

        
      </Grid>
    </Grid>
    
    );
  }
  
  HeadSectionCampaignComponent.propTypes = {
    title:PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
    tooltipTitle: PropTypes.string.isRequired,
    tooltipTitle2: PropTypes.string.isRequired,
    onAddButtonClick: PropTypes.func.isRequired,
    onSecondaryAddButtonClick: PropTypes.func.isRequired,
    customStyle: PropTypes.shape({
      container: PropTypes.string,
      sectionTitle: PropTypes.string,
      sectionSubTitle: PropTypes.string,
      sectionIconButton: PropTypes.string,
      sectionIcon: PropTypes.string,  
    })

  };

  export default HeadSectionCampaignComponent
